import { graphql } from 'gql';

export const bimWorkOrderChangeObjectSelectionListGql = graphql(`
    query bimWorkOrderChangeObjectSelectionList(
        $order: [BimWorkOrderChangeObjectSelectionDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderChangeObjectSelectionDataFilterInput
        $workOrderChangeId: Long!
    ) {
        bimWorkOrderChangeObjectSelectionList(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderChangeId: $workOrderChangeId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                fromWorkOrder
                workOrderObjectId
                workOrderChangeId
                isActKC2Object
                isIncluded
                id
                contractId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                parentId
                rootObjectId
                status
                name
                hasGuaranteedVolume
                objectSeasonDistributions {
                    id
                    contractSeason {
                        id
                        year
                    }
                    seasonValue
                }
                rationale
                order
                hasPrices
                hasActsKC2
                isInUse
            }
            totalCount
        }
    }
`);

export const bimWorkOrderChangeObjectSelectionListIsIncludedGql = graphql(`
    query bimWorkOrderChangeObjectSelectionListIsIncluded(
        $order: [BimWorkOrderChangeObjectSelectionDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderChangeObjectSelectionDataFilterInput
        $workOrderChangeId: Long!
    ) {
        bimWorkOrderChangeObjectSelectionList(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderChangeId: $workOrderChangeId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                isIncluded
                id
                constructionType {
                    id
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
            }
            totalCount
        }
    }
`);

export const bimWorkOrderChangeSeasonsGql = graphql(`
    query bimWorkOrderChangeSeasons($workOrderChangeId: Long!) {
        bimWorkOrderChangeSeasons(workOrderChangeId: $workOrderChangeId) {
            data {
                firstSeason {
                    id
                    workOrderSeason {
                        id
                        workOrderId
                        workOrderSeasonId
                        year
                    }
                    contractSeason {
                        id
                        year
                    }
                }
                lastSeason {
                    id
                    workOrderSeason {
                        id
                        workOrderId
                        workOrderSeasonId
                        year
                    }
                    contractSeason {
                        id
                        year
                    }
                }
            }
        }
    }
`);

export const bimIncludeContractObjectToWorkOrderChangeGql = graphql(`
    mutation bimIncludeContractObjectToWorkOrderChange($contractObjectId: Long!, $workOrderChangeId: Long!) {
        bimIncludeContractObjectToWorkOrderChange(
            contractObjectId: $contractObjectId
            workOrderChangeId: $workOrderChangeId
        ) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimExcludeContractObjectFromWorkOrderChangeGql = graphql(`
    mutation bimExcludeContractObjectFromWorkOrderChange($contractObjectId: Long!, $workOrderChangeId: Long!) {
        bimExcludeContractObjectFromWorkOrderChange(
            contractObjectId: $contractObjectId
            workOrderChangeId: $workOrderChangeId
        ) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateWorkOrderChangeObjectGql = graphql(`
    mutation bimCreateWorkOrderChangeObject($input: BimContractObjectCreateInput!, $workOrderChangeId: Long!) {
        bimCreateWorkOrderChangeObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateWorkOrderChangeSubObjectGql = graphql(`
    mutation bimCreateWorkOrderChangeSubObject($input: BimContractSubObjectCreateInput!, $workOrderChangeId: Long!) {
        bimCreateWorkOrderChangeSubObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderChangeObjectGql = graphql(`
    mutation bimUpdateWorkOrderChangeObject($input: BimContractObjectUpdateInput!, $workOrderChangeId: Long!) {
        bimUpdateWorkOrderChangeObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderChangeSubObjectGql = graphql(`
    mutation bimUpdateWorkOrderChangeSubObject($input: BimContractSubObjectUpdateInput!, $workOrderChangeId: Long!) {
        bimUpdateWorkOrderChangeSubObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderChangeSeasonsGql = graphql(`
    mutation bimUpdateWorkOrderChangeSeasons($workOrderChangeId: Long!, $contractSeasonId: Long!) {
        bimUpdateWorkOrderChangeSeasons(workOrderChangeId: $workOrderChangeId, contractSeasonId: $contractSeasonId) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimWorkOrderChangeLastSeasonSelectionListGql = graphql(`
    query bimWorkOrderChangeLastSeasonSelectionList($workOrderChangeId: Long!) {
        bimWorkOrderChangeLastSeasonSelectionList(workOrderChangeId: $workOrderChangeId) {
            id
            year
        }
    }
`);
